import type { TOC } from '@ember/component/template-only';

import styles from './card-overlay.module.css';

interface HotelBenchmarkInsightCardOverlaySignature {
  Args: {};
  Blocks: {
    default: [];
  };
}

const HotelBenchmarkInsightCardOverlay = <template>
  <div
    class="{{styles.card-overlay}} flex flex-col items-center justify-center"
  >
    {{yield}}
  </div>
</template> satisfies TOC<HotelBenchmarkInsightCardOverlaySignature>;

export default HotelBenchmarkInsightCardOverlay;
